import { ConfigService } from '../../';

/*& Models/Configs/Search
	# SearchConfig
*/
export class SearchConfig {
	public color		= '#BBB';
	public wrapper	= '#333';

	constructor(private configService: ConfigService) {}

	update(config: any): SearchConfig {
		if (typeof config.search === 'object') {
			this.color		= this.configService.getColor(config.search.color, this.color);
			this.wrapper	= this.configService.getColor(config.search.wrapper, this.wrapper);
		}

		return this;
	}
}



// WEBPACK FOOTER //
// ./src/app/electraLib/model/config/searchConfig.ts